import { Box, Grid } from "@mui/material";
import Icon from "components/templatesComponents/Icon";
import Pictogram from "components/templatesComponents/Pictogram";
import PropTypes from "prop-types";
import React from "react";

const Result = (props) => {
  const { pictogram: pictogramProp = "", icon = null, number = "", text = "", ...others } = props;
  const { folder, pictogram } = pictogramProp || {};

  return (
    <Grid component="li" size={{ xs: 12, sm: 6, lg: 3 }}>
      <div className="fr-card fr-card--lg fr-card--grey">
        <div className="fr-card__body">
          <div className="fr-card__content fr-p-3w">
            <h3 className="fr-card__title">
              {icon && <Icon {...icon} sx={{ color: "var(--blue-cumulus-main-526)", mr: 1.25 }} />}
              {number}
            </h3>
            {folder && pictogram && (
              <div className="fr-card__start">
                <Box
                  sx={{
                    width: 64,
                    "& .fr-artwork-decorative, & .fr-artwork-major, & .fr-artwork-minor": {
                      fill: "var(--grey-0-1000)",
                    },
                  }}
                >
                  <Pictogram folder={folder} pictogram={pictogram} />
                </Box>
              </div>
            )}
            {text && <p className="fr-card__desc fr-text--md">{text}</p>}
          </div>
        </div>
      </div>
    </Grid>
  );
};

Result.propTypes = {
  pictogram: PropTypes.shape(),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  text: PropTypes.string,
  details: PropTypes.node,
};

export default Result;
